export default __webpack_public_path__ + "static/media/kaminski.694162a1.jpg";